import type React from "react";
import DateRangeSelector from "../../../components/DateRangeSelector";

interface Props {
  data: any;
  dataRange: string;
  fromDate: string;
  toDate: string;
  onDateRangeChange: (value: string) => void;
  onFromDateChange: (date: string) => void;
  onToDateChange: (date: string) => void;
}

const StatusMetrics: React.FC<Props> = ({
  data,
  dataRange,
  fromDate,
  toDate,
  onDateRangeChange,
  onFromDateChange,
  onToDateChange,
}) => {
  // Turn your data into an array of key/value rows
  const metrics = [
    { label: "Registrations", value: data?.samples ?? 0 },
    { label: "Performed Tests", value: data?.tests ?? 0 },
    { label: "Approved Tests", value: data?.approvedTest ?? 0 },
    { label: "Gross Amount", value: data?.grossAmount ?? 0 },
    { label: "Total Income", value: data?.earning ?? 0 },
    { label: "Due Amount", value: data?.dueAmount ?? 0 },
    { label: "Total Discount", value: data?.discount ?? 0 },
  ];

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold mb-4 text-gray-700">
          Status Metrics:{" "}
          {dataRange === "custom"
            ? `from ${fromDate} to ${toDate}`
            : `${dataRange}`}
        </h3>
        <DateRangeSelector
          preset="lab"
          compact
          dateRange={dataRange}
          fromDate={fromDate}
          toDate={toDate}
          onDateRangeChange={onDateRangeChange}
          onFromDateChange={onFromDateChange}
          onToDateChange={onToDateChange}
        />
      </div>
      <dl className="divide-y divide-gray-200">
        {metrics.map(item => (
          <div key={item.label} className="flex justify-between py-2">
            <dt className="text-sm font-medium text-gray-600">{item.label}</dt>
            <dd className="text-sm font-bold text-right text-gray-800">
              {item.value.toLocaleString()}{" "}
            </dd>
          </div>
        ))}
      </dl>
    </div>
  );
};

export default StatusMetrics;
